<template>
  <div class="its-teaching-title">
      <div class="its-title">{{title}}</div>
  </div>
</template>
<script>
export default {
  name:'ClassTitle',
  props:{
    title:{
      type:String,
      default:function(){
        return ''
      }
    }
  }
}
</script>
<style scoped>
    .its-teaching-title{
        text-align: center;
    }
    .its-teaching-title .its-title{
        line-height: 1;
        font-size: 42px;
        color: #404857;
        font-weight: 600;
        margin-top: 100px;
    }
    .its-teaching-title .its-border{
        height: 8px;
        border-radius: 4px;
        background: #4390FF;
        width: 95px;
        margin-top: 35px;
        margin:  35px auto 0 auto;
    }
</style>